import './app.scss'
import templateUrl from './app.html'

/**
 * App component.
 *
 * Root application component used in index.html
 * Contains the 3 application views: `main` and `sidebar`, defined in {@link tmrDefaultAppState}
 *
 * @example
 * <tmr-app flex layout="column"></tmr-app>
 *
 * @type {ngComponent}
 */
export const tmrApp = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrAppController',
}

/**
 * Controller of component {@link tmrApp}.
 *
 * @type {ngController}
 */
export class tmrAppController {
  static ngType = 'controller'

  constructor(
    $rootElement,
    $stateParams,
    $transitions,
    TmrLocalStorage,
    UserStorage
  ) {
    'ngInject'
    Object.assign(this, {
      $rootElement,
      $stateParams,
      $transitions,
      TmrLocalStorage,
      UserStorage,
    })
  }

  $onInit() {
    this.startLoadingCancel = this.startLoading()
    this.stopLoadingSuccessCancel = this.stopLoadingSuccess()
    this.stopLoadingErrorCancel = this.stopLoadingError()
    this.fixed = this.TmrLocalStorage.get('sidebarExpanded', true)
    this.collapsed = !this.fixed
    this.$rootElement.toggleClass('tmr-sidebar-fixed', this.fixed)
    this.$rootElement.toggleClass('tmr-sidebar-expanded', !this.collapsed)
  }

  $onDestroy() {
    // Cancel transition hooks.
    this.startLoadingCancel()
    this.stopLoadingSuccessCancel()
    this.stopLoadingErrorCancel()
  }

  startLoading() {
    return this.$transitions.onStart({ to: 'app.**' }, trans => {
      this.loading = !trans.params().skipLoader
    })
  }

  stopLoadingSuccess() {
    return this.$transitions.onSuccess(
      { to: 'app.**' },
      () => (this.loading = false)
    )
  }

  stopLoadingError() {
    return this.$transitions.onError(
      { to: 'app.**' },
      () => (this.loading = false)
    )
  }

  showSidebar() {
    return this.$stateParams.hideSidebar !== true && this.userIsAuthenticated()
  }

  userIsAuthenticated() {
    return this.UserStorage.isAuthenticated()
  }

  collapseSidebar() {
    if (!this.fixed) this.collapsed = true
    this.$rootElement.removeClass('tmr-sidebar-expanded')
  }

  expandSidebar() {
    if (!this.fixed) this.collapsed = false
    this.$rootElement.addClass('tmr-sidebar-expanded')
  }

  fixSidebar() {
    this.TmrLocalStorage.set('sidebarExpanded', true)
    this.fixed = true
    this.$rootElement.addClass('tmr-sidebar-fixed')
  }

  unfixSidebar() {
    this.TmrLocalStorage.set('sidebarExpanded', false)
    this.fixed = false
    this.collapsed = true
    this.$rootElement.removeClass('tmr-sidebar-fixed')
  }
}
